<footer class="relative bg-blueGray-200 pt-8 pb-6" style="direction: rtl;">
  <!-- <div
    class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
    style="transform: translateZ(0)"
  >
    <svg
      class="absolute bottom-0 overflow-hidden"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      version="1.1"
      viewBox="0 0 2560 100"
      x="0"
      y="0"
    >
      <polygon
        class="text-blueGray-200 fill-current"
        points="2560 0 2560 100 0 100"
      ></polygon>
    </svg>
  </div> -->

  <div class="container mx-auto px-4">
    <div class="flex flex-wrap text-right ">
      <div class="w-full lg:w-6/12 px-4">
        <h4 class="text-3xl font-semibold"> با ما در ارتباط باشید </h4>
        <h5 class="text-lg my-2 text-blueGray-600">
          شما می توانید از طریق راه های زیر با ما در تماس باشید.
        </h5>
        <div class="mt-6 lg:mb-0 mb-6">
          <div class="flex my-2">
            <a href="mailto:ostadvisit@gmail.com">
            <button
              class=" text-primary font-normal w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
              type="button">
              <i class="fa fa-envelope"></i>
            </button>
            <span> ostadvisit&#64;gmail.com </span>
            </a>
          </div>
          <div class="flex my-2">
            <a href="tel:07132333076">
            <button
              class=" text-primary font-normal w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
              type="button" >
              <i class="fa fa-phone"></i>
            </button>
            <span> 07132333076 </span>
            </a>
          </div>          
        </div>
      </div>
      <div class="w-full lg:w-6/12 px-4">
        <div class="flex flex-wrap items-top mb-6">
          <div class="w-full lg:w-4/12 px-4 ml-auto">
            <span
              class="block uppercase text-blueGray-500 text-sm font-semibold mb-2"
            >
              صفحات
            </span>
            <ul class="list-unstyled">
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  href="https://www.creative-tim.com/presentation?ref=na-footer"
                >
                  درباره ما
                </a>
              </li>
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  href="https://blog.creative-tim.com?ref=na-footer"
                >
                  مجله سلامت
                </a>
              </li>
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  href="https://www.github.com/creativetimofficial?ref=na-footer"
                >
                  قوانین و مقررات
                </a>
              </li>
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  href="https://www.creative-tim.com/bootstrap-themes/free?ref=na-footer"
                >
                  حریم خصوصی
                </a>
              </li>
            </ul>
          </div>
          <!-- <div class="w-full lg:w-4/12 px-4">
            <span
              class="block uppercase text-blueGray-500 text-sm font-semibold mb-2"
            >
              Other Resources
            </span>
            <ul class="list-unstyled">
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  href="https://github.com/creativetimofficial/notus-angular/blob/main/LICENSE.md?ref=creativetim"
                >
                  MIT License
                </a>
              </li>
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  href="https://creative-tim.com/terms?ref=na-footer"
                >
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  href="https://creative-tim.com/privacy?ref=na-footer"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                  href="https://creative-tim.com/contact-us?ref=na-footer"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div> -->
        </div>
      </div>
    </div>
    <hr class="my-6 border-blueGray-300" />
    <div class="flex flex-wrap items-center md:justify-between justify-center">
      <div class="w-full md:w-4/12 px-4 mx-auto text-center">
        <div class="text-sm text-blueGray-500 font-semibold py-1">
          کلیه حقوق برای  
          <a
            href="#"
            class="text-blueGray-500 hover:text-blueGray-800"
          >
            استاد ویزیت
          </a>
          محفوظ است © {{ date }}
        </div>
      </div>
    </div>
  </div>
</footer>
